import $http from '$http'
import {util} from 'utils';
export default{
    methods:{
      getList () {
        var obj=this.form;
        if(obj.BindTimeStart!=""&&obj.BindTimeStart!=undefined){
            obj.BindTimeStart=new Date(obj.BindTimeStart).toLocaleDateString();
        }
        if(obj.BindTimeEnd!=""&&obj.BindTimeEnd!=undefined){
            obj.BindTimeEnd=new Date(obj.BindTimeEnd).toLocaleDateString();
        }
        var props={};
        for(var p in obj){
            if(obj[p]!=""){
                props[p]=obj[p];
                Object.assign({},props)
            }
        };
        this.lists=[];
        this.loading=true;//拼命加载中显示
        var a = { Sid: this.sysSid, Session: this.sysSession, pageIndex: this.pageIndex, pageSize: this.pageSize };
        var Params=Object.assign({},a,props);
        $http.get("api/School/ZqwPlatform_GetHardList",Params).then(res=>{
            let { StateCode, StateMsg, Data,Cnt} = res.data;
            util.doResult(this,res,()=>{
                this.totalSize=Cnt;
                this.loading = false;//拼命加载中显示ss
                this.lists=Data;
            })
        })
      }
    },
}


// WEBPACK FOOTER //
// ./src/pages/school/SchoolEquipment/services.js